import { css, cx } from '@emotion/css';
import { LanguageSwitcher } from '@/features/language-switcher';
import { Logo } from '@/components/Logo';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

export const Header = () => {
  const { t } = useTranslation();

  return (
    <div
      className={cx(
        'flex py-2 justify-between items-center px-6 box-border sm:border-b-[0px] border-b-[1px] drop-shadow-xs bg-white',
        css`
          grid-column: 1 / 3;
          grid-row: 1 / 2;
          backdrop-filter: blur(15px);
          background-color: rgba(255, 255, 255, 0.8);
        `
      )}
    >
      <div className="flex items-center md:invisible hover:cursor-pointer">
        <Logo />
      </div>
      <div className="flex items-center">
        <div>
          <LanguageSwitcher />
        </div>
        <div className="items-center flex">
          <a
            href="javascript:void(Tawk_API.toggle())"
            className="chat-btn chat-btn-live text-xs"
          >
            {t('label.live_chat')} <span className="live-icon"></span>
          </a>
          <Suspense fallback={<div className="w-8 h-8" />}>
            <ProfileMenuButtonLazy />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

const ProfileMenuButtonLazy = lazy(() =>
  import('../user/ProfileMenuButton').then((module) => ({
    default: module.ProfileMenuButton,
  }))
);
